import { portalFooterStyles } from '@/styles/portalPageStyles';

interface PortalFooterProps {
  currentPage?: 'privacy' | 'terms' | 'sms-terms' | 'pricing' | 'contact';
}

function PortalFooter({ currentPage }: PortalFooterProps) {
  // Only show Pricing/Contact links on portal site (not on tenant subdomains where those routes don't exist)
  const hostname = window.location.hostname;
  const isPortalSite =
    hostname === 'checkademic.com' ||
    hostname === 'www.checkademic.com' ||
    hostname === 'checkademic.dev' ||
    hostname === 'www.checkademic.dev' ||
    hostname === 'localhost';

  const renderLink = (href: string, label: string, page: PortalFooterProps['currentPage']) => {
    if (currentPage === page) {
      return <span style={portalFooterStyles.currentPageText}>{label}</span>;
    }
    return <a href={href} style={portalFooterStyles.link}>{label}</a>;
  };

  return (
    <footer style={portalFooterStyles.container}>
      <p style={portalFooterStyles.text}>
        {renderLink('/privacy', 'Privacy Policy', 'privacy')}
        {' \u00b7 '}
        {renderLink('/terms', 'Terms of Service', 'terms')}
        {' \u00b7 '}
        {renderLink('/sms-terms', 'SMS Terms', 'sms-terms')}
        {isPortalSite && (
          <>
            {' \u00b7 '}
            {renderLink('/pricing', 'Pricing', 'pricing')}
            {' \u00b7 '}
            {renderLink('/contact', 'Contact', 'contact')}
          </>
        )}
      </p>
      <p style={portalFooterStyles.text}>&copy; {new Date().getFullYear()} Checkademic. All rights reserved.</p>
    </footer>
  );
}

export default PortalFooter;
